var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58383 17.6763V5.27751L20.0288 3.37001V15.7688M8.58383 17.6763C8.58383 19.2565 7.3028 20.5375 5.72258 20.5375C4.14235 20.5375 2.86133 19.2565 2.86133 17.6763C2.86133 16.096 4.14235 14.815 5.72258 14.815C7.3028 14.815 8.58383 16.096 8.58383 17.6763ZM20.0288 15.7688C20.0288 17.349 18.7478 18.63 17.1676 18.63C15.5874 18.63 14.3063 17.349 14.3063 15.7688C14.3063 14.1885 15.5874 12.9075 17.1676 12.9075C18.7478 12.9075 20.0288 14.1885 20.0288 15.7688Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.7c4e9edba18326219eb5522eef75693c.svg";
export { ForwardRef as ReactComponent };